export default __webpack_public_path__ + "static/media/gallery07.25982b2a.jpg";